/** A registration checkbox, as the server serves it. */
export interface RegistrationConsentConfig {
  enabled: boolean
  label: string
  purpose: string
  required?: boolean
  version?: string
}

/** Registration checkboxes keyed by kind (`terms`, `marketing_email`). */
export type RegistrationConsents = Record<string, RegistrationConsentConfig>

export type ConsentStatus = 'not_recorded' | 'opted_in' | 'opted_out' | 'accepted'

/** One kind's stored choice for a (tenant, consumer), from `consent_state`. */
export interface ConsentStateRow {
  enabled: boolean
  status: ConsentStatus
  recorded_at: string | null
  source: string
  source_label: string
  label: string
  purpose: string
  version?: string
  current_version?: string
}

export type ConsentState = Record<string, ConsentStateRow>

/** Checkboxes to render, in the order the server sent them. */
export function registrationConsentEntries(
  config?: RegistrationConsents | null,
): Array<[string, RegistrationConsentConfig]> {
  return Object.entries(config ?? {}).filter(
    ([, cfg]) => cfg.enabled && cfg.label.trim() !== '',
  )
}

/** Unticked required boxes block a submit; the form highlights them. */
export function missingRequiredConsents(
  config: RegistrationConsents | null | undefined,
  values: Record<string, boolean>,
): string[] {
  return registrationConsentEntries(config)
    .filter(([kind, cfg]) => cfg.required && !values[kind])
    .map(([kind]) => kind)
}
